// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={70}
    height={70}
    viewBox="0 0 70 70"
    {...props}
  >
    <g clipPath="url(#clip0_4686_46332)">
      <rect
        width={70}
        height={70}
        rx={35}
        fill="#FF9D33"
      />
      <path
        d="M70.7023 114.474C61.3665 106.329 41.9675 88.2476 29.3643 58.706L52.5721 48.7594C64.4006 76.9051 82.9235 90.2715 89.406 95.6176L70.7023 114.474Z"
        fill="#29A9FF"
      />
      <path
        d="M52.7574 48.4814C51.3791 51.371 42.7561 55.3616 38.1108 57.2407C44.394 55.5314 53.7101 61.5382 57.2487 64.6393L59.513 62.4317C58.8043 61.8861 54.6414 52.7541 52.7574 48.4814Z"
        fill="#005DE5"
      />
      <path
        d="M48.9376 52.2645C51.3807 50.7407 52.7876 49.403 52.487 48.7105C52.1864 48.0179 50.3764 48.1271 47.7258 48.8012C45.0785 49.5059 42.4919 50.414 39.9878 51.518C37.6612 52.5083 35.405 53.6557 33.2338 54.9527C30.5968 56.5642 29.0549 57.9803 29.366 58.6907C29.6771 59.4012 31.4002 59.2725 33.9609 58.6459C36.6668 57.9368 39.3094 57.0133 41.865 55.8834C44.3088 54.8539 46.6725 53.6444 48.9376 52.2645Z"
        fill="#0078EF"
      />
      <path
        d="M48.9119 52.0104C51.355 50.4866 52.8618 49.3566 52.5612 48.6641C52.2606 47.9715 50.4507 48.0807 47.8 48.7549C45.1527 49.4595 42.5661 50.3677 40.062 51.4716C37.7354 52.4619 35.4792 53.6093 33.308 54.9063C30.671 56.5178 29.1291 57.9339 29.4402 58.6444C29.7513 59.3548 31.4744 59.2261 34.0351 58.5995C36.7411 57.8904 39.3836 56.9669 41.9392 55.837C44.383 54.8075 46.6468 53.3903 48.9119 52.0104Z"
        stroke="#37363F"
        strokeWidth={0.504865}
        strokeMiterlimit={10}
      />
      <path
        d="M54.0791 22.9722C52.2153 21.5031 49.609 21.9767 48.0787 23.729C44.9283 27.3236 42.7813 33.2915 42.7813 33.2915C40.1538 26.5478 38.2583 19.9156 37.8144 14.8459C37.6197 12.706 36.129 10.7924 34.0437 10.4959C33.4211 10.4027 32.7895 10.4499 32.1936 10.6343C31.5977 10.8188 31.0521 11.1359 30.5958 11.5631C30.1394 11.9902 29.7835 12.5169 29.5531 13.1059C29.3228 13.6948 29.2236 14.3316 29.2629 14.9708C29.5206 19.3185 32.0103 27.2861 34.0315 33.1609L33.6817 33.3124C31.3944 28.7118 28.0781 21.3945 23.1814 14.2973C22.586 13.4217 21.7135 12.7791 20.7158 12.4815C19.718 12.1839 18.6582 12.2501 17.7207 12.6685C17.1644 12.9352 16.6747 13.3238 16.2857 13.8071C15.8967 14.2905 15.6177 14.8569 15.468 15.4674C15.3183 16.0778 15.3015 16.7175 15.4189 17.342C15.5362 17.9665 15.7849 18.5608 16.1475 19.0837C20.1257 24.9712 23.6766 31.1412 26.7708 37.5429L26.6567 37.6571L26.4805 37.8335C24.264 34.2751 21.7543 30.9114 18.9795 27.7802C18.2571 26.9643 17.2764 26.435 16.218 26.2898C15.1596 26.1445 14.0949 26.3932 13.2201 26.9899C12.7244 27.3474 12.3128 27.8117 12.0135 28.3511C11.7141 28.8906 11.5339 29.4925 11.4854 30.1158C11.4368 30.739 11.5209 31.3689 11.732 31.9625C11.9431 32.5562 12.2761 33.0996 12.7085 33.5557C18.3957 39.5776 23.6467 45.802 32.1296 59.0451C36.0259 58.5571 46.7483 54.0097 51.3928 50.2532C48.4878 44.5041 49.0396 37.9326 54.677 29.4489C56.0709 27.3577 56.176 24.6267 54.0791 22.9722Z"
        fill="#ABE3FF"
      />
      <path
        d="M23.8894 41.3162C23.8894 41.3162 25.5829 35.6036 38.2929 31.5985"
        stroke="#37363F"
        strokeWidth={0.504865}
        strokeMiterlimit={10}
      />
      <path
        d="M42.795 33.306C40.1675 26.5623 38.272 19.93 37.8281 14.8604C37.6334 12.7204 36.1426 10.8068 34.0574 10.5103C33.4348 10.4171 32.8032 10.4643 32.2073 10.6488C31.6114 10.8332 31.0658 11.1504 30.6095 11.5775C30.1531 12.0047 29.7972 12.5314 29.5668 13.1203C29.3365 13.7093 29.2373 14.346 29.2766 14.9852C29.5343 19.333 32.024 27.3005 34.0451 33.1753L33.6884 33.3268C31.4011 28.7262 28.085 21.4088 23.1882 14.3115C22.5928 13.4359 21.7204 12.7933 20.7226 12.4957C19.7249 12.1981 18.665 12.2643 17.7276 12.6827C17.1713 12.9494 16.6816 13.338 16.2925 13.8213C15.9035 14.3047 15.6244 14.8713 15.4747 15.4818C15.325 16.0922 15.3084 16.7317 15.4257 17.3562C15.5431 17.9807 15.7917 18.5751 16.1544 19.0979C20.1326 24.9854 23.6833 31.1556 26.7774 37.5573L26.4872 37.8479C24.2707 34.2895 21.7611 30.9257 18.9863 27.7944C18.264 26.9786 17.2831 26.4494 16.2247 26.3041C15.1663 26.1589 14.1016 26.4076 13.2268 27.0043C12.7311 27.3618 12.3195 27.8261 12.0202 28.3655C11.7208 28.905 11.5407 29.5068 11.4922 30.13C11.4436 30.7532 11.5278 31.3831 11.7389 31.9768C11.95 32.5704 12.283 33.1138 12.7153 33.5699C18.4025 39.5918 23.6536 45.8162 32.1365 59.0593C35.8837 58.5929 46.2257 54.313 51.3928 50.2532C48.4878 44.5041 49.0463 37.947 54.6837 29.4633C56.0637 27.3718 56.1827 24.634 54.0789 22.9722C52.2151 21.5031 49.6088 21.9767 48.0785 23.729C44.9281 27.3236 42.7811 33.2915 42.7811 33.2915C42.7811 33.2915 37.0777 34.6523 36.2809 40.9572"
        stroke="#37363F"
        strokeWidth={0.504865}
        strokeMiterlimit={10}
      />
    </g>
    <defs>
      <clipPath id="clip0_4686_46332">
        <rect
          width={70}
          height={70}
          rx={35}
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
const SvgMarkOrange = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgMarkOrange;
